export default __webpack_public_path__ + "static/media/k_color.b22173d0.png";